import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-conmet-input',
  styleUrls: ['./conmet-input.component.scss'],
  template: `
    <div class='d-flex' *ngIf='label'>
      <label *ngIf='label'>{{ label }}</label>
      <label *ngIf='!label'>&nbsp;</label>
    </div>
    <div class='d-flex' [formGroup]='group'><input
      class='form-control {{validationCheckFunc()}}'
      type='text'
      [attr.placeholder]='label'
      [formControlName]='formname'
      [attr.disabled]='disable'
    />
    </div>
  `
})
export class ConmetInputComponent implements OnInit {
  @Input() group: FormGroup;
  @Input() label: string;
  @Input() formname: string;
  @Input() disable: string;
  @Input() validation: boolean;
  @Input() validationCheck: boolean;

  constructor() {
    this.disable = null;
  }

  ngOnInit() {
  }

  validationCheckFunc() {
    if (this.validation) {
      return this.validationCheck ? 'is-valid' : 'is-invalid';
    }

    return '';
  }
}
